<template>
 <div>
  <label for="pat-tipo-bem-select" class="form-label">Tipo de Bem:</label>
  <MultiSelect
   v-model="selectedObjeto"
   :options="objeto"
   mode="single"
   :searchable="true"
   :close-on-select="true"
   valueProp="valor"
   trackBy="texto"
   label="texto"
   placeHolder="Selecione um Tipo de Bem"
   id="pat-tipo-bem-select"
  />
 </div>
</template>

<script lang="ts">
 import { defineComponent, ref, onMounted, watch } from "vue";
 import servico from "@/services/patrimonio/pattipobem/pattipobem.service";

 interface TextoValorOpcional {
  valor: number | null;
  texto: string;
 }

 export default defineComponent({
  name: "DropDownListComponente",
  props: {
   modelValue: {
    type: Number,
    default: null,
   },
   permitirEmBranco: {
    type: Boolean,
    default: false,
   },
   textoItemEmBranco: {
    type: String,
    default: "Todos",
   },
  },
  emits: ["update:modelValue"],
  setup(props, { emit }) {
   const objeto = ref<TextoValorOpcional[]>([]);
   const selectedObjeto = ref<number | null>(props.modelValue);
   const loading = ref(false);

   const fetchObjeto = async () => {
    loading.value = true;
    try {
     const result = await servico.DropDownList();
     const itens = result.map((item) => ({
      valor: item.valor,
      texto: item.texto,
     }));

     objeto.value = props.permitirEmBranco
      ? [{ valor: null, texto: props.textoItemEmBranco }, ...itens]
      : itens;

     if (!objeto.value.some((item) => item.valor === props.modelValue)) {
      selectedObjeto.value = null;
     }
    } catch (err) {
     console.error("Erro ao carregar Tipo de Bem:", err);
    } finally {
     loading.value = false;
    }
   };

   watch(
    () => props.modelValue,
    (newValue) => {
     selectedObjeto.value = newValue;
    },
    { immediate: true },
   );

   watch(selectedObjeto, (newValue) => {
    emit("update:modelValue", newValue);
   });

   onMounted(fetchObjeto);

   return {
    objeto,
    selectedObjeto,
    loading,
   };
  },
 });
</script>
